<div class="modals return-information" [class.modals-show]="isModalReturnsInformationShow">
  <div class="returns-information">
    <p>
      Усі повернення та зміни, корегування в замовленнях приймаємо через заявку на повернення на сайті. Меню-кнопка
      «зміни та повернення замовлень».
      У ваших замовленнях також є кнопка "заявка на повернення", де можливо оформити повернення або внести зміни до
      замовлення, або поміняти дату відправки.
    </p>
    <p>
      Замовні позиції обміну та поверненню не підлягають. Партнерський склад – це замовна позиція. Терміни доставки
      партнерських пропозицій можуть змінюватись, можуть бути відмови постачання.
    </p>
    <p>
      Якщо сформований маршрут доставки замовлення і Замовник відмовляється від Товару, в такому випадку Замовник
      сплачує вартість доставки товару!Замовник сплачує вартість упаковки навіть при відмові від отримання Товару.
    </p>
    <p>
      Приймати товар потрібно у присутності представника постачальника або перевізника! Після прийняття Товару будь-які
      претензії щодо зовнішнього вигляду товару та цілісності не приймаються!
    </p>
    <p>
      Умови обміну/повернення товару належної якості відбувається згідно з вимогами діючого законодавства України.
      Стаття 9. Відповідно до Закону України «Про захист прав споживачів»:
      Споживач має право обміняти непродовольчий товар належної якості на аналогічний у продавця, у якого він був
      придбаний, якщо товар не задовольнив його за формою, габаритами, фасоном, кольором, розміром або з інших причин не
      може бути ним використаний за призначенням. Споживач має право на обмін товару належної якості протягом
      чотирнадцяти днів, не рахуючи дня купівлі.
    </p>
    <p>
      Обмін товару належної якості проводиться:
      якщо він не використовувався;
      якщо збережено його товарний вид, споживчі властивості, пломби, ярлики;
      При поверненні товару належної якості, витрати на транспортування товару до магазина бере на себе покупець.
      Роз'яснення: Товарний вигляд: під товарним виглядом слід розуміти відсутність слідів використання, цілісність
      пломб, ярликів, наклейок, упаковочних матеріалів.
      Умови обміну/повернення товару неналежної якості:
    </p>
    <p>
      Стаття 8. Відповідно до Закону України «Про захист прав споживачів»:
      У разі виявлення протягом встановленого гарантійного строку недоліків споживач, в порядку та у строки, встановлені
      законодавством, має право вимагати:
      пропорційного зменшення ціни;
      повернення коштів;
      безоплатного усунення недоліків товару в розумний строк;
      відшкодування витрат на усунення недоліків товару.
      Вимоги споживача, передбачені цією статтею, не підлягають задоволенню, якщо продавець, виробник (підприємство, що
      задовольняє вимоги споживача, встановлені частиною першою цієї статті) доведуть, що недоліки товару виникли
      внаслідок порушення споживачем правил користування товаром або його зберігання.
    </p>
  </div>

  <div class="row">
    <div class="column text-center">
      <a href="/orders" class="button btn-return-information-modal" (click)="closeModal()">Ознайомлений</a>
    </div>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
